// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"cb3470af","703":"3ec3a8fb","787":"ca680e37"}[chunkId] + ".chunk.js";
};